<template>
    <q-input
        v-if="type == 'text' || type == 'email' || type == 'number'"
        v-model="innerValue"
        :type="type"
        v-bind="defaultInputProps"
        :class="{ required: required && !modelValue }"
    >
        <template v-for="(_, slot) in $slots" #[slot]="scope">
            <slot :name="slot" v-bind="{...scope}" />
        </template>
    </q-input>

    <q-input
        v-else-if="type == 'textarea'"
        v-model="innerValue"
        v-bind="defaultInputProps"
        :class="{ required: required && !modelValue }"
        type="textarea"
        autogrow
    >
        <slot />
    </q-input>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: null,
    required: Boolean,
    readonly: Boolean,
    type: {
        type: String,
        default: 'text',
    },
    modelModifiers: {
        type: Object,
        default: () => ({}),
    },
})

const emit = defineEmits(['update:model-value'])

const rules = props.required
    ? [val => !!val || '* Required']
    : []

const innerValue = computed({
    get: () => props.modelValue,
    set: val => {
        // If using v-model.number then make sure we actually get a number
        if (props.modelModifiers?.number) {
            let parsed = parseFloat(val)
            val = parsed || parsed === 0 ? parsed : null
        }
        emit('update:model-value', val)
    },
})

const defaultInputProps = computed(() => ({
    filled: !props.readonly,
    borderless: props.readonly,
    readonly: props.readonly,
    rules,
    dense: true,
    hideBottomSpace: true,
    step: 'any',
}))
</script>
